<template>
  <div class="content w-full">
    <TopNavbar />
    <div class="page-content">
      <DynamicVisibility ref="dynamicVisibility">
        <template #primary>
          <DeveloperOverviewComponent :goBackVisible="true" @toggle-visibility="toggleVisibility" />
        </template>

        <template #secondary>
					<DeveloperListComponent />
        </template>
      </DynamicVisibility>
    </div>
  </div>
</template>

<script>
import TopNavbar from '@/components/user/layout/TopNavbar.vue';
import DeveloperListComponent from './DeveloperListComponent.vue';
import AppOverviewComponent from "@/components/user/viewComponent/app/AppOverviewComponent.vue";
import DynamicVisibility from "@/components/custom/visibility/DynamicVisibility.vue";
import DeveloperOverviewComponent from "@/components/user/viewComponent/developer/DeveloperOverviewComponent.vue";

export default {
	name: 'ListsViewComponent',
	components: {
		TopNavbar,
		DeveloperListComponent,
		AppOverviewComponent,
		DynamicVisibility,
    DeveloperOverviewComponent,
	},
  methods: {
    toggleVisibility(visible) {
      this.$refs.dynamicVisibility.toggle(visible);
    },
  },
};
</script>